import React, { Fragment, useEffect, useState } from "react";
import { Collapse } from "antd";

import Container from "@/components/container/Container";
import CardComponent from "@/components/card";

import "@/styles/pages/faq/faq.scss";
import BackWithLabel from "@/components/common/BackWithLabel";
import IconMinus from "@/components/icons/IconMinus";
import IconAdd from "@/components/icons/IconAdd";
import ContactByWhatsApp from "@/pages/contact-us/ContactByWhatsApp";
import { getFAQs } from "@/services/common/getFAQ";

const { Panel } = Collapse;

const customExpandIcon = ({ isActive }) => (isActive ? <IconMinus /> : <IconAdd />);

const FaQ = () => {
  const [data, setData] = useState([]);

  const transformResponseData = (responseData) => {
    return responseData.map((row) => ({
      title: row.name,
      questionAndAnswers: row.faqs.map((faq) => ({
        question: faq.question,
        answer: faq.answer,
      })),
    }));
  };
  useEffect(() => {
    getFAQs().then((res) => {
      const formattedData = transformResponseData(res);
      setData(formattedData || []);
    });
  }, []);

  return (
    <Fragment>
      <div className="faq-main">
        <Container>
          <CardComponent>
            <div className="heading">
              <BackWithLabel label="Frequently Asked Questions (FAQs)" />
            </div>
            <div className="according">
              <Collapse expandIconPosition="right" className="accordion">
                {data.map((item, index) => {
                  return (
                    <Fragment key={index}>
                      <Panel header={item.title} key={index + 1}>
                        <div className="outer-accordion-content">
                          {item.questionAndAnswers.map((questionAndAnswer, i) => {
                            return (
                              <Fragment key={i}>
                                <div className="inner-accordion">
                                  <Collapse
                                    accordion
                                    expandIcon={customExpandIcon}
                                    expandIconPosition="right"
                                    className="accordion"
                                  >
                                    <Panel
                                      header={`${i + 1}. ${questionAndAnswer.question}`}
                                      key={i + 1}
                                    >
                                      <div className="content">
                                        <div
                                          dangerouslySetInnerHTML={{
                                            __html: questionAndAnswer.answer,
                                          }}
                                        />
                                      </div>
                                    </Panel>
                                  </Collapse>
                                </div>
                              </Fragment>
                            );
                          })}
                        </div>
                      </Panel>
                    </Fragment>
                  );
                })}
              </Collapse>
            </div>

            <div className="whatsapp-contact">
              <ContactByWhatsApp />
            </div>
          </CardComponent>
        </Container>
      </div>
    </Fragment>
  );
};

export default FaQ;
